import { Grid, makeStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React from 'react'

const useStyles = makeStyles(() => ({
  root: {
    height: 100,
    borderRadius: 24,
    background: '#FFFFFF',
    padding: 20,
    paddingBottom: 0
  },
  valueLabel: {
    marginTop: 5
  },
  icon: {
    marginRight: 5
  }
}))

const NumberWidgetSkeleton = () => {
  const classes = useStyles()

  return (
    <Grid container className={classes.root} wrap="nowrap">
      <Grid className={classes.icon}>
        <Skeleton variant="circle" width={40} height={40} />
      </Grid>
      <Grid container direction="column">
        <Grid>
          <Skeleton variant="text" width="100%" height={40} />
        </Grid>
        <Grid>
          <Skeleton variant="text" width={100} height={20} />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default NumberWidgetSkeleton
